import React, { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { FaEyeSlash, FaEye } from "react-icons/fa";
const AddNew = () => {
  const [password, setPassword] = useState();
  const [show, setShow] = useState(false)
  const showPassoword = () => setShow(!show);
  const [passwordError, setPasswordError] = useState();

  const { setSubheading } = useOutletContext();

  useEffect(() => {
    setSubheading("Initiate New Assessment");
    return () => {
      setSubheading("");
    };
  }, [setSubheading]);

  return (
    <>
        <div className="flex gap-x-3 justify-between items-center my-6 md:my-10">
            <span class="text-xl font-bold mr-auto">Add User</span>
            <Link to="/user-role-management" className='z-10 px-4 border-[1px] !border-secondary hover:!bg-secondary py-2.5 md:py-[14px] rounded-xl text-[15px] md:min-w-32 text-center !text-secondary hover:text-white font-semibold transition-all'>Cancel</Link>
            <Link to="/user-role-management" className='z-10 border-[2px] !border-primary !bg-primary px-4 py-2.5 md:py-[14px] rounded-xl text-center text-[15px] md:min-w-32 text-white'>Add</Link>
        </div>
        <div className="row col-md-12">
            <div className="col-md-3 mb-4">
                <label>User Name</label>
                <input className="w-full h-[54px] border-[1px] border-[#0B3E64] rounded-3 bg-transparent mt-2 outline-none px-3"/>
            </div>
            <div className="col-md-3 mb-4">
                <label>Email</label>
                <input className="w-full h-[54px] border-[1px] border-[#0B3E64] rounded-3 bg-transparent mt-2 outline-none px-3"/>
            </div>
            <div className="col-md-3 mb-4">
                <label>Phone</label>
                <input className="w-full h-[54px] border-[1px] border-[#0B3E64] rounded-3 bg-transparent mt-2 outline-none px-3"/>
            </div>
            <div className="col-md-3 mb-4">
                <label>Assign Role</label>
                <select className="w-full h-[54px] border-[1px] border-[#0B3E64] rounded-3 bg-transparent mt-2 outline-none px-2.5">
                    <option>Super Admin</option>
                    <option>Admin</option>
                </select>
            </div>
            <div className="col-md-3 mb-4">
                <label>Set Password</label>
                <div className="relative">
                  <input 
                    type={show ? "text" : "password"}
                    className="w-full h-[54px] border-[1px] border-[#0B3E64] rounded-3 bg-transparent mt-2 outline-none pl-3 pr-10"
                    onChange={(e) => { setPasswordError(''); setPassword(e.target.value) }}
                  />
                  <div className="pos-abs hide-show-pass mt-1 !right-4" onClick={showPassoword}>
                    {show ? <FaEye /> : <FaEyeSlash />}
                  </div>
                </div>
                
            </div>
        </div>
    </>
  );
};

export default AddNew;